import { Icon as _Icon } from 'tdesign-icons-vue-next';

import { withInstall } from '@tdesign/shared-utils';

export const Icon = withInstall(_Icon, 'TIcon');

export default Icon;
